import React from 'react'
import './EditAlbum.scss'
import HeaderWhite from '../../components/HeaderWhite'
import { Uploader, Button, Icon } from 'rsuite'
import NavbarColor from '../../components/NavbarColor'
import axios from 'axios'
import { toast } from 'react-toastify'
import LoadingModal from './LoadingModal/LoadingModal'
import CustomInput from '../components/custom/CustomInput'
import {EditPicture, getBase64FromImage, getUrlFromImage, resizeBlob, textarea_max_length} from '../components/Helper'

class EditAlbum extends React.Component {
	state = {
		numeAlbum: "",
		description: "",
		linkPozaCopertaAlbum: "",
		pozaAlbum: null,
		linkPozeAlbum: "",
		base64ImageLink: "",
		loading: false,
		loadingData: true
	}

	async componentDidMount() {
		let auth = {
			headers: {
				'Authorization': 'Bearer ' + localStorage.getItem('jwt')
			}
		}

		await axios.get(process.env.REACT_APP_DOMAIN + 'albums/' + this.props.match.params.idAlbum, auth)
			.then(response => {
				this.setState({
					numeAlbum: response.data.numeAlbum,
					description: response.data.descriereAlbum,
					linkPozaCopertaAlbum: response.data.image,
					linkPozeAlbum: response.data.linkPozeAlbum,
					loadingData: false
				})
			})
			.catch(err => {
				console.log(err);
				toast.error("Eroare, va rog reincercati")
				this.goBack()
			})
	}

	handleChange = (value, event) => {
		this.setState({
			[event.target.name]: value
		})
	}

	changeAlbumDescription = (value) => {
		if (this.state.description.length > textarea_max_length - 1 && value.length > textarea_max_length - 1) {
			return
		}

		this.setState({
			description: value
		})
	}

	editAlbum = async () => {
		if (this.state.numeAlbum === "") {
			toast.error("Nu ati completat titlul")
			return;
		}

		this.setState({
			loading: true
		})

		let obj = {
			numeAlbum: this.state.numeAlbum,
			descriereAlbum: this.state.description,
			linkPozeAlbum: this.state.linkPozeAlbum,
			imageLink: this.state.base64ImageLink,
		}

		/*
		let formData = new FormData()
		formData.append("data", JSON.stringify(obj))

		if (this.state.pozaAlbum !== null) {
			formData.append("files.image", this.state.pozaAlbum)
		}
		 */

		let auth = {
			headers: {
				//"Content-Type": `multipart/form-data;`,
				'Authorization': 'Bearer ' + localStorage.getItem('jwt')
			}
		}

		axios.put(process.env.REACT_APP_DOMAIN + 'albums/edit/' + this.props.match.params.idAlbum, obj, auth)
			.then(async response => {
				toast.success("Album modificat cu succes!")

				this.setState({
					loading: false
				})

				this.goBack()
			})
			.catch(err => {
				console.log(err.message);
				toast.error("Eroare")
			})
	}

	handlePoza = async (fileList) => {
		if (fileList.length === 0) {
			this.setState({
				pozaAlbum: null
			})
			return
		}

		let blob = await resizeBlob(fileList[0].blobFile)

		this.setState({
			pozaAlbum: blob,
		})
	}

	saveCroppedImage = async (croppedImg) => {
		let img = {}
		img.blobFile = croppedImg
		let data = await getBase64FromImage(img)

		this.setState({
			croppedImage: croppedImg,
			base64ImageLink: data
		})
	}

	goBack = () => {
		this.props.history.go(-1)
	}

	render() {
		if (this.state.loadingData) {
			return <div className="EditAlbum-container">
				<p>Loading...</p>
			</div>
		}

		return (
			<div className="EditAlbum-container">
				<HeaderWhite goBack={this.goBack} />

				<LoadingModal loading={this.state.loading} />

				<div className="EditAlbum-contents">
					<h4 id="title"> Editeaza Album </h4>

					<div className="input-zone">
						<CustomInput value={this.state.numeAlbum} onChange={value => this.setState({ numeAlbum: value })} placeholder={"Nume Album"}
							style={{ margin: "10px 0px" }} icon={<Icon icon="text-height" />} />

						<CustomInput value={this.state.description} onChange={this.changeAlbumDescription} placeholder={`Descriere Album ${this.state.description.length}/${textarea_max_length}`}
							style={{ margin: "10px 0px" }} componentClass={"textarea"} icon={<Icon icon="pencil" />} />

						{this.state.linkPozaCopertaAlbum !== null
							? <div>
								<p>Imagine coperta album</p>
								<img style={{ padding: "5px", width: "300px", height: "300px", alignSelf: "center" }} src={`https://${process.env.REACT_APP_IMAGE_DOMAIN}${getUrlFromImage(this.state.linkPozaCopertaAlbum)}`} alt="" />
							</div>
							: <p>Nicio imagine adaugata</p>
						}

						<div className="Upload-zone">
							<div style={{ textAlign: "left" }}> Adauga poza pt coperta album </div>

							<Uploader onChange={this.handlePoza} accept=".jpg" style={{ borderRadius: "5px" }}
								autoUpload={false} multiple={false} disabled={this.state.pozaAlbum !== null}>
								<div style={{ color: "#221d5d", width: "100%", height: "100%" }} id="text"> Click aici pentru a incarca fotografii </div>
							</Uploader>
						</div>

						{this.state.pozaAlbum !== null && <EditPicture imageLink={URL.createObjectURL(this.state.pozaAlbum)} saveCroppedImage={this.saveCroppedImage} />}

						<div style={{ textAlign: "left" }}>Albumul va fi vizibil pentru participanti doar daca ati adaugat link de drive</div>
						<CustomInput value={this.state.linkPozeAlbum} onChange={value => this.setState({ linkPozeAlbum: value })} placeholder={"Link catre poze album"}
							style={{ margin: "10px 0px" }} icon={<Icon icon="link" />} />

						<div className="Footer">
							<Button onClick={this.editAlbum} className="add-button" style={{ backgroundColor: "#00afcc", color: "white" }}>Salveaza Album</Button>
						</div>
					</div>
				</div>

				<NavbarColor history={this.props.history} />
			</div>
		)
	}
}

export default EditAlbum;